import { render, staticRenderFns } from "./QuestionPairs.vue?vue&type=template&id=25551338&scoped=true&lang=pug"
import script from "./QuestionPairs.vue?vue&type=script&lang=js"
export * from "./QuestionPairs.vue?vue&type=script&lang=js"
import style0 from "./QuestionPairs.vue?vue&type=style&index=0&id=25551338&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25551338",
  null
  
)

export default component.exports